import { Box, Heading } from '@optiaxiom/react';
import { NavLink, Outlet } from 'react-router-dom';
import { PrLaneBadge } from '@/components/ui/PrLaneBadge';
import styles from './AppLayout.module.css';

const NAV_ITEMS = [
  { to: 'apps', label: 'Apps' },
  { to: 'api-key', label: 'API Key' },
];

function NavItem({ to, label }: { to: string; label: string }) {
  return (
    <Box asChild className={styles.navItem} color="fg.avatar.neutral">
      <NavLink to={to}>{label}</NavLink>
    </Box>
  );
}

export function AppLayout() {
  return (
    <div className={styles.shell}>
      <aside className={styles.sidebar}>
        <Heading level="4" fontWeight="700" className={styles.brand}>
          Developer Portal
        </Heading>
        <nav className={styles.nav}>
          {NAV_ITEMS.map((item) => (
            <NavItem key={item.to} to={item.to} label={item.label} />
          ))}
        </nav>
      </aside>
      <main className={styles.content}>
        <Outlet />
      </main>
      <PrLaneBadge />
    </div>
  );
}
